import React from 'react';

import styled, { css, keyframes } from 'styled-components';

import { Box } from '@adsk/alloy-react-box';
import theme from '@adsk/alloy-react-theme';

const keyFrames = keyframes`
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
`;

const animation = css`
  animation: ${keyFrames} 1.3s linear infinite;
`;

const LoadingAnimation = styled.div`
  background-image: linear-gradient(
    to right,
    transparent,
    ${theme.colors.charcoal300},
    transparent
  );
  width: 100%;
  height: 100%;
  ${animation}
`;

const InlineLoader = () => {
  return (
    <Box
      width="100%"
      height="10px"
      minWidth="40px"
      overflow="hidden"
      backgroundColor="charcoal100"
    >
      <LoadingAnimation />
    </Box>
  );
};

export default InlineLoader;
